
  var tests = [];
  module.exports = tests;




//////////////////
// WEBPACK FOOTER
// ./~/browsernizr/lib/tests.js
// module id = 56
// module chunks = 0